import React from '@root/vendor/react';

const ExperienceContext = React.createContext();

export default ExperienceContext;
